import React from 'react';

import { SORTABLE_PIPELINE_FIELDS } from '@ion/api';

import TextCell from 'app/components/data-table/TextCell';
import TimestampCell from 'app/components/data-table/TimestampCell';
import IntegrationsCell from 'app/components/data-table/IntegrationsCell';
import TagsCell from 'app/components/data-table/TagsCell';
import PipelineStatusChip from 'app/shared/components/pipelines/PipelineStatusChip';

import ActionsCell from './cells/ActionsCell';
import PipelineConfigCell from './cells/PipelineConfigCell';

const CONFIG_COLUMN_WIDTH = '120px';

export default function buildPipelinesTableColumns({ showTags = false } = {}) {
  return [
    {
      name: 'Pipeline Name',
      cell: row => <TextCell bubbleClickEvent text={row.name} />,
      sortable: true,
      sortField: SORTABLE_PIPELINE_FIELDS.name,
    },
    {
      name: 'Integrations',
      cell: row => <IntegrationsCell bubbleClickEvent integrations={extractIntegrations(row.pipelineIntegrations)} />,
      sortable: true,
      sortField: SORTABLE_PIPELINE_FIELDS.integrations,
    },
    {
      name: 'Writekey',
      cell: row => <TextCell bubbleClickEvent text={row.writekey} />,
      sortable: true,
      sortField: SORTABLE_PIPELINE_FIELDS.writekey,
    },
    {
      name: 'Cluster',
      cell: row => <TextCell bubbleClickEvent text={row.cluster.name} />,
      sortable: true,
      sortField: SORTABLE_PIPELINE_FIELDS.cluster,
    },
    {
      name: 'Config',
      cell: row => (
        <PipelineConfigCell
          hasPipelineFilter={row.hasPipelineFilter}
          hasPipelineTransform={row.hasPipelineTransform}
          hasPipelineEventSplit={row.hasPipelineEventSplit}
        />
      ),
      center: true,
      width: CONFIG_COLUMN_WIDTH,
    },
    ...(showTags
      ? [
          {
            name: 'Tags',
            cell: row => <TagsCell tags={row.pipelineTags} />,
            width: '250px',
          },
        ]
      : []),
    {
      name: 'Status',
      cell: row => <PipelineStatusChip status={row.status} />,
    },
    {
      name: 'Last Deployed',
      cell: row => <TimestampCell timestamp={row.lastDeployed} />,
    },
    {
      button: true,
      cell: row => <ActionsCell row={row} />,
    },
  ];
}

function extractIntegrations(pipelineIntegrations) {
  return pipelineIntegrations.map(({ integration }) => ({
    starterkitId: integration.starterkitId,
    name: integration.name,
  }));
}
